import { render, staticRenderFns } from "./PlanningBrigades.vue?vue&type=template&id=177412a6&scoped=true"
import script from "./PlanningBrigades.vue?vue&type=script&lang=js"
export * from "./PlanningBrigades.vue?vue&type=script&lang=js"
import style0 from "./PlanningBrigades.vue?vue&type=style&index=0&id=177412a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177412a6",
  null
  
)

export default component.exports